import type { JsonObject } from '@backstage/types';

export function getGcpProjectIdFromForm(formData: JsonObject | undefined): string | undefined {
  const raw = formData?.gcpProject;
  if (raw && typeof raw === 'object' && !Array.isArray(raw) && 'gcpId' in raw) {
    const id = (raw as { gcpId?: unknown }).gcpId;
    return typeof id === 'string' ? id : undefined;
  }
  return undefined;
}
